import { createAction } from 'redux-actions';

export const toggleBoxShadow = createAction('TOGGLE_BOX_SHADOW');
